module.exports = __webpack_public_path__ + "static/media/143.52ba1e5e.svg";